
<template>
<div>
  <div v-if="show&&(phone && windowWidth < windowHeight)" class="signatureBox signatureBox1">
    <div class="canvasBox" style="display:flex" ref="canvasHW">
      <div v-if="show" class="btnBox" :style="status == '0' ? {top: '45%'} : ''">
        <button @click="overwrite" style="background:#BC6FFF;border-radius:40px;width:120px;height:40px">重签</button>
        <button @click="surewrite" style="background:#71B9FC;border-radius:40px;width:120px;height:40px">提交</button>
      </div>
      <div v-if="show" class="closeBox">
        <span>温馨提示：请用中文签写公司法人代表名字:</span><span style="color:red">{{realname}}</span>
      </div>
      <canvas
        class="canvas_box"
        @touchstart="touchStart"
        @touchmove="touchMove"
        @touchend="touchEnd"
        v-if="show"
        ref="canvasF"
        @mousedown="mouseDown"
        @mousemove="mouseMove"
        @mouseup="mouseUp"
      ></canvas>
      <div class="tit">签名输入框:</div>
    </div>
  </div>
    <div v-if="show&&(!phone || windowWidth > windowHeight)" class="signatureBox">
      <div class="canvasBox" ref="canvasHW">
        <div class="tit">签名输入框:</div>
        <canvas
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
          v-if="show"
          ref="canvasF"
          @mousedown="mouseDown"
          @mousemove="mouseMove"
          @mouseup="mouseUp"
        ></canvas>
        <div v-if="show" class="closeBox">
          <span>温馨提示：请用中文签写公司法人代表名字:</span><span style="color:red">{{realname}}</span>
        </div>
        <div v-if="show" class="btnBox" style="width:300px">
          <button @click="overwrite" style="background:#BC6FFF;border-radius:40px;width:120px;height:40px">重签</button>
          <button @click="surewrite" style="background:#71B9FC;border-radius:40px;width:120px;height:40px">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendSignImg,austriaSendSignImg,getCompanySign,austriaZeroDeclare, saveSignPicForDeclare } from "@/api/sign";
import { debounce } from "@/util/util.js";
// import axios from "axios";
export default {
  name: "signature",
  data() {
    return {
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      isDown: false,
      color: "#000",
      linewidth: 3,
      imgBase64: "",
      isDraw: false, //签名标记
      show: true,
      realname: '',
      windowHeight: undefined,
      windowWidth:undefined,
      phone:true,
      status: undefined
    };
  },
  created() {
    document.title = '手写签名-麦德通'
    this.windowWidth = document.documentElement.clientWidth || document.body.clientWidth
    this.windowHeight = document.documentElement.clientHeight  || document.body.clientHeight
  },
  mounted() {
    let phone = navigator.userAgent;//设备机型的相关信息
    phone = phone.substring(phone.indexOf('(')+1,phone.indexOf(';'));//处理信息，输出phone
    console.log(phone.indexOf('Windows') == -1,phone.indexOf('Macintosh') == -1,phone.indexOf('iPad') == -1,phone.indexOf('iPad'),'--------------设备信息--------------------')
    if ((phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1 && phone.indexOf('iPad') == -1)) {
      this.phone = true
    } else {
      this.equipment = false
      this.phone = false
    }
    if (!this.$route.query.taxIdKey && !this.$route.query.declareIdKey && !this.$route.query.identifInfoIdKey && !this.$route.query.zeroDeclareIdKey && !this.$route.query.applyIdKey) {
      this.show = false;
      return this.$toast({
        message: "二维码已失效，请重新扫码",
        duration: 3000,
        position: top
      })
    }
    if (this.$route.query.realname) {
      this.realname = this.$route.query.realname
    }
    let canvas = this.$refs.canvasF;
    if ((this.phone && this.windowWidth < this.windowHeight)) {
      canvas.height = this.windowHeight - 2;
      canvas.width = this.windowWidth - 150;
    } else {
      canvas.height = this.windowHeight * 0.6;
      canvas.width = this.windowWidth - 10;
    }
    this.canvasTxt = canvas.getContext("2d");
    this.canvasTxt.strokeStyle = this.color;
    this.canvasTxt.lineWidth = this.linewidth;
    const that = this
    window.onresize = () => {
      that.$toast({message: '系统已为您适配，请关闭旋转模式'})
      that.overwrite()
      that.windowWidth = document.documentElement.clientWidth || document.body.clientWidth
      that.windowHeight  = document.documentElement.clientHeight  || document.body.clientHeight
      if ((that.phone && that.windowWidth < that.windowHeight)) {
        that.status = '0'
        canvas.height = that.windowHeight-2;
        canvas.width = that.windowWidth - 150;
      } else {
        that.status = '1'
        canvas.height = that.windowHeight * 0.6;
        canvas.width = that.windowWidth - 10;
      }
    }
  },
  components: {},
  methods: {
    //电脑设备事件
    mouseDown(ev) {
      this.isDraw = true; //签名标记
      ev = ev || event;
      ev.preventDefault();
      let obj = {
        x: ev.offsetX,
        y: ev.offsetY
      };
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.points.push(obj);
      this.isDown = true;
    },
    //移动设备事件
    touchStart(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        this.isDraw = true; //签名标记
        let obj = {}; //y的计算值中：document.body.offsetHeight*0.5代表的是除了整个画板signatureBox剩余的高，this.$refs.canvasHW.offsetHeight*0.1是画板中标题的高
         if (this.windowWidth < this.windowHeight && this.phone) {
           obj = {
              x: ev.targetTouches[0].clientX-120,
              y: ev.targetTouches[0].clientY
            };
         } else {
           obj = {
              x: ev.targetTouches[0].clientX,
              y: ev.targetTouches[0].clientY - 55
            };
         }
        this.startX = obj.x;
        this.startY = obj.y;
        this.canvasTxt.beginPath();
        this.points.push(obj);
      }
    },
    //电脑设备事件
    mouseMove(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (this.isDown) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        };
        this.moveY = obj.y;
        this.moveX = obj.x;
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.startY = obj.y;
        this.startX = obj.x;
        this.points.push(obj);
      }
    },
    //移动设备事件
    touchMove(ev) {
      ev = ev || event;
      ev.preventDefault();
      let obj = {}
      if (this.windowWidth < this.windowHeight && this.phone) {
           obj = {
              x: ev.targetTouches[0].clientX-120,
              y: ev.targetTouches[0].clientY
            };
         } else {
           obj = {
              x: ev.targetTouches[0].clientX,
              y: ev.targetTouches[0].clientY - 55
            };
         }
      this.moveY = obj.y;
      this.moveX = obj.x;
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.stroke();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    //电脑设备事件
    mouseUp(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (1) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        };
        this.canvasTxt.closePath();
        this.points.push(obj);
        this.points.push({ x: -1, y: -1 });
        this.isDown = false;
      }
    },
    //移动设备事件
    touchEnd(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {};
        if (this.windowWidth < this.windowHeight && this.phone) {
           obj = {
              x: ev.targetTouches[0].clientX-120,
              y: ev.targetTouches[0].clientY
            };
         } else {
           obj = {
              x: ev.targetTouches[0].clientX,
              y: ev.targetTouches[0].clientY - 55
            };
         }
        this.canvasTxt.closePath();
        this.points.push(obj);
        this.points.push({ x: -1, y: -1 });
      }
    },
    //重写
    overwrite() {
      this.canvasTxt.clearRect(
        0,
        0,
        this.$refs.canvasF.width,
        this.$refs.canvasF.height
      );
      this.points = [];
      this.isDraw = false; //签名标记
    },
    //确认签名
    surewrite:debounce(function() {
      if (this.isDraw) {
        let toast1 = this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0
      });
        let imgBase64 = undefined
        let api = null
        let params = {}
        if (this.$route.query.declareIdKey) {
          api = austriaSendSignImg
          params.declareIdKey = this.$route.query.declareIdKey
        } else if (this.$route.query.taxIdKey) {
          api = sendSignImg
          params.taxIdKey = this.$route.query.taxIdKey
        } else if (this.$route.query.identifInfoIdKey) {
          api = getCompanySign
          params.identifInfoIdKey = this.$route.query.identifInfoIdKey
        } else if (this.$route.query.zeroDeclareIdKey){
          api = austriaZeroDeclare
          params.zeroDeclareIdKey = this.$route.query.zeroDeclareIdKey
        } else if (this.$route.query.applyIdKey) {
          api = saveSignPicForDeclare
          params.applyIdKey = this.$route.query.applyIdKey
        }
        if (this.phone && this.windowWidth < this.windowHeight) {
          this.rotateBase64(this.$refs.canvasF.toDataURL()).then((img) => {
            imgBase64 = img
            params.file = this.dataURLtoFile(imgBase64, "name")
            api(params).then(res => {
              if (res.code == 500) {
                this.$toast({
                  message: res.msg,
                  duration: 3000,
                  position: top
                })
              }
              if (res.code == 0) {
                this.$toast.success('上传成功，请关闭当前页面')
                this.show =false
                this.$router.push({
                  name: 'signSuccess'
                })
              }
              setTimeout(() => {toast1.clear()},3000)
            }).catch(err => {
              console.log(err,'-----------err------------')
              setTimeout(() => {toast1.clear()},3000)
              this.$toast({message: '网络不稳定，请稍后重试'})
            })
          });
        } else {
          imgBase64 = this.$refs.canvasF.toDataURL()
          params.file = this.dataURLtoFile(imgBase64, "name")
          api(params).then(res => {
            if (res.code == 500) {
              this.$toast({
                message: res.msg,
                duration: 3000,
                position: top
              })
            }
            if (res.code == 0) {
              this.$toast.success('上传成功，请关闭当前页面')
              this.show =false
              this.$router.push({
                name: 'signSuccess'
              })
            }
            setTimeout(() => {toast1.clear()},3000)
          }).catch(err => {
            console.log(err,'-----------err------------')
            setTimeout(() => {toast1.clear()},3000)
            this.$toast({message: '网络不稳定，请稍后重试'})
          })
        }
      } else {
        this.$toast({
          message: "请签字之后再提交",
          duration: 3000,
          position: top
        })
      }
    },500),
    rotateBase64(data){   //传入需要旋转的base64图片
        return new Promise((resolve, reject) => {
          const imgView = new Image();
          imgView.src = data;
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const cutCoor = {sx: 0, sy: 0, ex: 0, ey: 0}; // 裁剪坐标
          imgView.onload = () => {
            const imgW = imgView.width;
            const imgH = imgView.height;
            const size = imgH;
            canvas.width = size * 2;
            canvas.height = size * 2;
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            context.translate(size, size);
            context.rotate(Math.PI/2*3);
            context.drawImage(imgView, 0, 0);
            const imgData = context.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
            canvas.width = imgH;
            canvas.height = imgW;
            context.putImageData(imgData, 0, 0);
            resolve(canvas.toDataURL('image/png'));
          };
        });
      },
    dataURLtoFile(dataurl, filename) {
      // 调用如下
      let bold = this.dataURLtoBlob(dataurl);
      let file = this.blobToFile(bold, "sign");
      // 上传file就可以了
      return file;
    },
    //转成blob
    dataURLtoBlob(toDataURL) {
      var arr = toDataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      var blob = null;

      // 解决低版本浏览器没有new Blob()问题
      try {
        blob = new Blob([u8arr], { type: mime });
      } catch (e) {
        var BlobBuilder = (window.BlobBuilder =
          window.BlobBuilder ||
          window.WebKitBlobBuilder ||
          window.MozBlobBuilder ||
          window.MSBlobBuilder);

        if (e.name === "TypeError" && BlobBuilder) {
          var builder = new BlobBuilder();
          builder.append(u8arr);
          blob = builder.getBlob(mime);
        }
      }

      return blob;
    },
    //转成file
    blobToFile(Blob, fileName) {
      Blob.lastModifiedDate = new Date();
      Blob.name = fileName;
      return Blob;
    }
  }
};
</script>

<style scoped>
.signatureBox {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 100;
}
.signatureBox1{
  height: 100%;
}
.signatureBox1 .canvasBox{
  height: 100%;
}
.signatureBox1 .tit{
  position: absolute;
  right: -30px;
  top: 35px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg); 	/* IE 9 */
  -moz-transform:rotate(90deg); 	/* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
}
.signatureBox1 .closeBox{
  position: absolute;
  right: 118px;
  top: 190px;
  width: 100%;
  height: 20px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg); 	/* IE 9 */
  -moz-transform:rotate(90deg); 	/* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
}
.canvas_box {
  position: absolute;
  right: 50px;
  top: 0;
}
.signatureBox1 .btnBox{
  height: 1rem;
  margin: auto;
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
  right: 50%;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg); 	/* IE 9 */
  -moz-transform:rotate(90deg); 	/* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
}
.tit{
  text-align: left;
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  margin: 0 10px;
}
.canvasBox {
  padding: 0px 5px;
  height: 90%;
}
canvas {
  border: 1px dashed gray;
}
.btnBox {
  padding: 5px;
  text-align: center;
  line-height: 30px;
  display: flex;
}
.signatureBox .btnBox{
  padding: 5px;
  text-align: center;
  line-height: 30px;
  display: flex;
  margin: auto;
  justify-content: space-between;
}

.btnBox button {
  border: 1px solid dodgerblue;
  background: dodgerblue;
  color: #fff;
  border-radius: 4px;
  padding: 2px 30px;
  margin: 0 15px;
  font-size: 14px;
  outline: none;
}
.closeBox {
  text-align: center;
  height: 10%;
}
.closeBox span {
  font-size: 13px;
  float: left;
}
.closeBox p {
  font-size: 22px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  border: none;
  background: gray;
  color: white;
  float: right;
}
@media only screen and (min-width: 730px) {
  /* .signatureBox {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 50%;
    background: darkgray;
    box-sizing: border-box;
    overflow: visible;
  } */
}
</style>



// WEBPACK FOOTER //
// src/views/sign.vue